export default __webpack_public_path__ + "1c3d9849a9b8744ee2cb381fb10ab0d0.png";